module.exports = __webpack_public_path__ + "static/media/0FoxStNW_2018-06-25_190.bbaf0315.jpg";